var radioButtonGroupTypeData = ['default', 'pills', 'bubble', 'pointer', 'list'];
export default radioButtonGroupTypeData;